import api from '../config/api';

/**
 * Send order details to the customer's WhatsApp via backend CloudWhatsApp API.
 * @param {string|number} orderId
 * @returns {Promise<{ success: boolean, mobile?: string, message?: string }>}
 */
export async function sendOrderDetailsWhatsApp(orderId) {
  const response = await api.post(`/orders/${orderId}/share-whatsapp`);
  return response.data;
}
